import type { LevelProtocol, RpeEntry } from '../types';
import { RPE_PATIENT_GUIDE } from './orstedRpe.ts';
import { CLINIC_30CM_STAGE_COSTS, CLINIC_PROTOCOL_VERSION } from '../../supabase/functions/_shared/clinic-protocol.ts';
export const CONSUMER_PROTOCOL_VERSION = CLINIC_PROTOCOL_VERSION;

export const LEVELS: LevelProtocol[] = [
  { n: 1, spm: 15, bpm: 60,  vo2: CLINIC_30CM_STAGE_COSTS[0] },
  { n: 2, spm: 20, bpm: 80,  vo2: CLINIC_30CM_STAGE_COSTS[1] },
  { n: 3, spm: 25, bpm: 100, vo2: CLINIC_30CM_STAGE_COSTS[2] },
  { n: 4, spm: 30, bpm: 120, vo2: CLINIC_30CM_STAGE_COSTS[3] },
  { n: 5, spm: 35, bpm: 140, vo2: CLINIC_30CM_STAGE_COSTS[4] },
];

export const LEVEL_DURATION = 120; // seconds
export const DEV_LEVEL_DURATION = 10;
export const PRE_COUNTDOWN = 10; // seconds for level 1
export const DEV_PRE_COUNTDOWN = 3;
export const INLINE_COUNTDOWN = 3; // seconds for levels 2-5

export const RPE_SCALE: RpeEntry[] = RPE_PATIENT_GUIDE.map(entry => ({ ...entry }));

export function getLevelProtocol(level: number): LevelProtocol {
  return LEVELS[level - 1];
}
